/**
 * The app's version, put in the build by `npm start` and `npm run build`
 * (from scripts/version.sh). Empty when it wasn't (e.g. in tests).
 * @returns {string}
 */
export const appVersion = () => process.env.REACT_APP_VERSION || "";
